import { memo } from "react";

import { externalLink } from "@/routes/_constants/external-link";

/**
 * CHILLNN サポート「CHILLNNの費用について（基本料金/手数料タイプ）」
 * https://support.chillnn.com/faq/host/settlement/862fffe15c57825292c28192adfaa971
 *
 * ベースURLは externalLink.faqSite（dev/prd で自動切替）を使う。
 * パスは Notion ページ ID で構成されるため、日本語タイトルや旧スラッグは使わない。
 */
const BILLING_ABOUT_URL = `${externalLink.faqSite}/faq/host/settlement/862fffe15c57825292c28192adfaa971`;

export const Description = memo(() => {
	return (
		<div className="space-y-1">
			<p>販売に向けて、基本設定をしましょう！設定が完了するとチェックが入ります。</p>
			<p>設定が完了したら、料金プランを選択して販売を開始しましょう。</p>

			<div className="flex flex-wrap gap-x-2">
				<p>
					※
					<strong className="text-brand">
						トライアルや基本料金の無料期間中であっても、予約手数料は発生します。
					</strong>
					料金体系については
				</p>
				<a
					href={BILLING_ABOUT_URL}
					target="_blank"
					className="text-link-400 underline-offset-4 hover:underline"
				>
					こちら
				</a>
				<p>をご覧ください。</p>
			</div>
		</div>
	);
});

Description.displayName = "Description";
